/* Содержимое макета (site.json) на текущем языке: строки переводятся словарём `src/i18n/en/site.ts`. */
import raw from "./site.json";
import { tDeep } from "@/lib/i18n";

const site = tDeep(raw);
export default site;
